import { Reveal, Eyebrow } from "@/components/Reveal";

const AUDIENCES = [
  "Entrepreneurs",
  "Small businesses",
  "Local businesses",
  "Professional-service businesses",
  "Nonprofit organizations",
  "Churches & community organizations",
  "Creators",
  "Artists",
  "Startups",
  "E-commerce businesses",
  "Personal brands",
  "Technology ventures",
];

export const WhoWeServe = () => (
  <section className="relative py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <Eyebrow>Audience</Eyebrow>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white mt-4">
          Who We Serve
        </h2>
        <p className="text-slate-400 mt-4 max-w-2xl">
          All In Hand Marketing supports organizations at different stages of digital growth.
        </p>
      </Reveal>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3.5 mt-12">
        {AUDIENCES.map((a, i) => (
          <Reveal key={a} delay={Math.min(i * 0.04, 0.3)}>
            <div
              data-testid={`audience-card-${a.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="group h-full rounded-2xl border border-slate-800 bg-obsidian-800/50 hover:border-gold/40 hover:bg-obsidian-800 p-5 transition-all duration-300"
            >
              <span className="font-mono text-[10px] text-slate-600 group-hover:text-gold/70 transition-colors">
                {String(i + 1).padStart(2, "0")}
              </span>
              <p className="font-display font-semibold text-slate-200 group-hover:text-white mt-2 text-sm sm:text-base">
                {a}
              </p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <p className="text-slate-500 text-sm mt-8 max-w-2xl">
          Our approach is customized around the organization rather than forcing every customer into
          the same solution.
        </p>
      </Reveal>
    </div>
  </section>
);

export default WhoWeServe;
